import * as types from './mutation-types'

export default {
  [types.LOAD_PROPERTY_SPECIFICATIONS](state, data) {
    state.propertySpecifications = data.propertyCharacteristic
  },
  
}
